import React from "react";
import { useLocation } from "@reach/router";
import { Wrapper, SectionHeading } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { CompleteRegistrationForm } from "../../components";
var CompleteRegistrationPage = function () {
    var search = new URLSearchParams(useLocation().search);
    var code = search.get("code");
    var email = search.get("email");
    return (React.createElement(BaseLayout, null,
        React.createElement(Wrapper, { className: "wrapper-auth" },
            React.createElement(SectionHeading, null, "Complete Your Account"),
            React.createElement(CompleteRegistrationForm, { codeParam: code !== null && code !== void 0 ? code : "", emailParam: email !== null && email !== void 0 ? email : "" }))));
};
export default CompleteRegistrationPage;
//# sourceMappingURL=CompleteRegistrationPage.js.map